module.exports = "<div class=\"container-fluid mh\">\n    <div class=\"row\">\n        <div class=\"content-section\">\n            <div id=\"map\" class=\"mapView\"></div>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/map/map.html
// module id = 31
// module chunks = 0